import { inject, injectable } from "tsyringe";
import { COOKIES } from "@identity/symbols";

@injectable()
export class CookieRepository {
  constructor(@inject(COOKIES) private cookiesManager: CookiesManager) {}

  public get(name: string): string {
    return this.cookiesManager.get(name);
  }

  public set(name: string, trackingProperty: TrackingProperty): void {
    const { value, domain, expiresMS } = trackingProperty;
    const expirationDate = new Date(new Date().getTime() + expiresMS);

    this.cookiesManager.set(name, value.toString(), {
      domain,
      expires: expirationDate,
    });
  }

  public remove(name: string) {
    this.cookiesManager.remove(name);
  }
}
